import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { selectCurrentRunningPvPEventMapId, selectPVPUnitAmountByDollars, } from "../../../selectors/selectPVP";
import { TypeActionContractInfo } from "../../market/actionContractInfo";
import { actionPVPAddUnits } from "../actionPvp";
export var epicPVPAddUnits = function (action$, state$) {
    return action$.pipe(ofType(TypeActionContractInfo.Received), filter(function (action) {
        return selectCurrentRunningPvPEventMapId(state$.value) != undefined &&
            action.contractInfo != undefined &&
            action.contractInfo.earnings != undefined;
    }), switchMap(function (action) {
        var state = state$.value;
        var dollars = action
            .contractInfo.earnings.filter(function (earning) { return earning.typeId === IdResource.Money; })
            .reduce(function (accumulator, earning) {
            return accumulator.add(earning.amount || Long.ZERO);
        }, Long.ZERO);
        var units = selectPVPUnitAmountByDollars(state, dollars);
        return of(actionPVPAddUnits(units));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/pvp/epics/epicPVPAddUnits.ts
// module id = 2107
// module chunks = 3